import {UseCase} from '@s-ui/domain'

class GetAdvertisementsTrackingUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} param
   * @param {function} param.getAdvertisementsTrackingService
   */
  constructor({getAdvertisementsTrackingService}) {
    super()

    this._getAdvertisementsTrackingService = getAdvertisementsTrackingService
  }

  /**
   * @param {Object} param
   * @param {Object} param.ads
   * @param {Object} param.ad - MONOLITH
   * @param {Object} param.similarAds - MONOLITH
   * @param {Object} param.adsTypeName
   * @param {Object} param.context
   * @param {Object} param.listType
   * @param {Object} param.filters
   */
  execute = async ({ads, ad, similarAds, adsTypeName, context, listType, filters}) => {
    return this._getAdvertisementsTrackingService
      .execute({
        ads,
        ad,
        similarAds,
        adsTypeName,
        context,
        listType,
        filters
      })
      .then(advertisementVO => advertisementVO.toJSON())
  }
}

export default GetAdvertisementsTrackingUseCase
